import { gql } from '@apollo/client/core';

const optionHelper = {};

// Existing static options
optionHelper.stockAction = [
    { code: 1, label: 'Buy' },
    { code: 2, label: 'Sell' },
    { code: 3, label: 'Ipo' },
    { code: 4, label: 'Bonus' },
    { code: 5, label: 'Demerged' },
    { code: 6, label: 'Split' }
];

// GraphQL query to fetch options from the database
const GET_OPTIONS = gql`
  query GetOptions($model: String!, $labelColumn: String, $valueColumn: String) {
    getOptions(model: $model, labelColumn: $labelColumn, valueColumn: $valueColumn) {
      label
      value
    }
  }
`;

/**
 * Fetch options from GraphQL using the Apollo provider.
 * @param {Object} apolloProvider - The Apollo provider instance.
 * @param {string} labelColumn - The column name to use for labels.
 * @param {string} valueColumn - The column name to use for values.
 * @param {string} modelName - The name of the model to query.
 * @returns {Promise<Array>} - Returns a promise that resolves to an array of options.
 */
optionHelper.getOptionsFromGraphQL = async function(apolloProvider, labelColumn, valueColumn, modelName) {
  try {
    const { data } = await apolloProvider.query({
      query: GET_OPTIONS,
      variables: { model: modelName, labelColumn, valueColumn },
    });
    const modelData = data.getOptions;

    if (!modelData || !Array.isArray(modelData)) {
      console.error(`Invalid data received from the API for model: "${modelName}"`);
      return [];
    }

    return modelData;
  } catch (error) {
    console.error('Error fetching options from GraphQL:', error);
    return [];
  }
};

optionHelper.dropDownOptionArray = (jsonArray, code, label) => {
  let optionsArray = [];
  let jsonObj;

  // Parse if string
  if (typeof jsonArray === 'string') {
      try {
          jsonObj = JSON.parse(jsonArray);
      } catch (e) {
          console.error("Invalid JSON string passed to optionArray:", jsonArray);
          return [];
      }
  } else {
      jsonObj = jsonArray;
  }

  // If input is like [{'1': 'Buy', '2': 'Sell'}]
  if (Array.isArray(jsonObj) && jsonObj.length > 0) {
      jsonObj.forEach(element => {
          if (typeof code === 'undefined' || typeof label === 'undefined') {
              // For flat key-value object like {'1': 'Buy'}
              for (let key in element) {
                  if (Object.prototype.hasOwnProperty.call(element, key)) {
                      optionsArray.push({ code: key, label: element[key] });
                  }
              }
          } else {
              // For array of objects with defined code/label keys
              optionsArray.push({
                  code: element[code],
                  label: element[label]
              });
          }
      });
  }

  return optionsArray;
};


// Install function to make optionHelper available globally in the Vue app
export default {
    install: (app) => {
        app.config.globalProperties.$optionHelper = optionHelper; 
    },
};
